import type { FC } from 'react';

import type { ContactVariant, PrivateDataType } from '../../../../../domain/contact';

import { PrivateDataBaseItemView } from './PrivateDataBaseItemView';

type Props = {
  type: PrivateDataType;
  variant?: ContactVariant;
};

const EMAIL_PLACEHOLDER = 'alex.smith@company.com';

const PHONE_PLACEHOLDER = '(555) 987-6543';

const typeToPlaceholderMap: Record<PrivateDataType, string> = {
  email: EMAIL_PLACEHOLDER,
  'direct-phone': PHONE_PLACEHOLDER,
  'mobile-phone': PHONE_PLACEHOLDER,
};

export const PrivateDataBlurredItemView: FC<Props> = ({ type, variant }) => (
  <PrivateDataBaseItemView variant={variant} content={typeToPlaceholderMap[type]} type={type} withBluredContent />
);
